var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BFormCheckbox',{attrs:{"checked":!_vm.shippingDifferentFromBilling},on:{"change":function($event){return _vm.setShippingDifferentFromBilling(!_vm.shippingDifferentFromBilling)}}},[_vm._v("\n\tShipping is the same as billing\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }